// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__lCdgb","row":"styles_row__2cFDu"};